import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { Option } from '@amfam/ui-kit';

@Component({
  selector: 'amfam-choose-payment-amount',
  templateUrl: './choose-payment-amount.component.html',
  styleUrls: ['./choose-payment-amount.component.scss'],
  standalone: false
})
export class ChoosePaymentAmountComponent {
  @Input() choosePaymentAmountOptions: Option[];
  @Input() formGroup: UntypedFormGroup;
  @Output() textChangeEvent = new EventEmitter();
  @Output() radioChangeEvent = new EventEmitter();
  unselectAll = false;

  textBoxChangeEvent(event: MouseEvent | Event) {
    this.unselectAll = true;
    this.textChangeEvent.emit(event);
  }

  radioGroupChangeEvent(event: InputEvent) {
    this.unselectAll = false;
    this.radioChangeEvent.emit(event);
  }
}
